import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { BillOfQuantities } from '../services/bill-of-quantities/bill-of-quantities';
import { BillOfQuantititesStep } from '../types/bill-of-quantities-step';
import { getBillOfQuantitiesStepSegment } from '../utils/step-navigation.config';

const HOME_URL = '/computo-metrico';
const CREATE_URL = '/computo-metrico/create';

/**
 * Allows the activation of a creation step route only if it matches the current step of the
 * bill of quantities status.
 * The expected step must be declared in the route `data.step`.
 */
export const billOfQuantitiesStepGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const billOfQuantitiesService = inject(BillOfQuantities);

  const billOfQuantitiesId = Number(route.paramMap.get('billOfQuantitiesId'));
  const expectedStep = route.data['step'] as BillOfQuantititesStep;
  const homeUrlTree = router.createUrlTree([HOME_URL]);

  if (!Number.isInteger(billOfQuantitiesId) || billOfQuantitiesId <= 0) {
    return homeUrlTree;
  }

  return billOfQuantitiesService.getBillOfQuantitiesStatus(billOfQuantitiesId).pipe(
    map(({ currentStatus }) => {
      const currentStep = currentStatus.step;

      if (currentStep === expectedStep) {
        return true;
      }

      const segment = getBillOfQuantitiesStepSegment(currentStep);

      return segment
        ? router.createUrlTree([CREATE_URL, billOfQuantitiesId, segment])
        : homeUrlTree;
    }),
    catchError(() => of(homeUrlTree)),
  );
};
